import { Outlet, useMatches } from 'react-router-dom'
import { StepByStep } from '../../components/stepByStep'
import { BaseLayout } from '../layout'
import { ArrowLeft, ArrowRight } from 'lucide-react'

import './styles.scss'
import { useEffect, useLayoutEffect, useState } from 'react'
import { useSteps } from '../../hooks/setup/useSteps'
import { STEPS } from './constants'
import { KEY_SETUP_COMPANY, KEY_SETUP_USER } from '../../utils/constants'
import { useStepContext } from '../../hooks/setup/useStepContext'
import { Loader } from '../../components/loader'

export const Setup = () => {
  const { currentActive, setCurrentActive } = useStepContext()
  const { bulkRegisterSteps, steps, previousStep, getCurrentStepActive } =
    useSteps()
  const matches = useMatches()
  const [loading, setLoading] = useState(true)

  const isRouterCompany = matches.find(
    (match) => match.id === KEY_SETUP_COMPANY.toString()
  )

  useLayoutEffect(() => {
    const loadCreatedSteps = async () => {
      const listSteps = await steps()

      if (listSteps.length === 0) {
        await bulkRegisterSteps(STEPS)
      }

      setLoading(false)
    }

    loadCreatedSteps()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    const loadCurrentStep = async () => {
      const currentStep = await getCurrentStepActive()

      if (!currentStep) return

      setCurrentActive(currentStep.id)
    }

    loadCurrentStep()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const renderHeaderInfo = () => {
    if (currentActive === KEY_SETUP_USER)
      return <span className="text-info">Provenduz App - Configuração</span>

    return (
      <div
        className="content-info-header"
        onClick={async () => await previousStep()}
      >
        <ArrowLeft size={25} className="icon-info-header" />
        <span>Voltar</span>
      </div>
    )
  }

  if (loading) {
    return (
      <div className="container-load-setup">
        <Loader size={30} />
        <span className="text-load-setup">
          Estamos preparando tudo para você
        </span>
      </div>
    )
  }

  return (
    <BaseLayout>
      <header>
        {renderHeaderInfo()}

        <StepByStep />
      </header>

      <div className="container-page">
        <Outlet />
      </div>

      <footer
        style={{
          paddingBottom: isRouterCompany ? 0 : 77,
        }}
      >
        <span className="info-support">
          Precisa de ajuda?{' '}
          <a
            className="link-support"
            href={import.meta.env.VITE_URL_SUPPORT_LINK}
            target="_blank"
            rel="noopener noreferrer"
          >
            Contate Nosso Suporte <ArrowRight />
          </a>
        </span>
      </footer>
    </BaseLayout>
  )
}
